import { injectable } from 'inversify';
import 'reflect-metadata';
import { ERRORS } from '../constants/errors/error-messages.constants';
import LogHelper from '../helpers/log.helper';
import axiosClient from './axios-client';
import {
  MarketSnapshotCategory,
  MarketSnapshotCountry,
} from '../models/market-snapshot.model';
import { ApiResponse } from '../utils/api-response.utils';

@injectable()
export class MarketSnapshotService {
  logger: LogHelper;

  constructor(logger = new LogHelper()) {
    this.logger = logger;
  }

  async getMarketSnapshot(
    country: string
  ): Promise<ApiResponse<MarketSnapshotCategory[]>> {
    try {
      const response = await axiosClient.get<
        ApiResponse<MarketSnapshotCategory[]>
      >(`/api/market-snapshot?country=${country}`);
      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getAvailableCountries(): Promise<ApiResponse<MarketSnapshotCountry[]>> {
    try {
      const response = await axiosClient.get<
        ApiResponse<MarketSnapshotCountry[]>
      >(`/api/market-snapshot/countries`);
      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
